// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import StyledBox, { StyledBoxStyles } from "@sc/XDL/Components/Common/Box";
import * as React from "react";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

type Props = OwnProps & HasProduct;

export interface ProductDetailsCustomAvailabilityMessageStyles {
    container?: StyledBoxStyles;
    title?: TypographyPresentationProps;
    message?: TypographyPresentationProps;
}

export const customAvailabilityMessageStyles: ProductDetailsCustomAvailabilityMessageStyles = {};

const styles = customAvailabilityMessageStyles;

const ProductDetailsCustomAvailabilityMessage = ({ productInfo, fields }: Props) => {
    const { inventory } = productInfo || {};
    const { title } = fields;

    if (!productInfo || !inventory?.additionalResults?.customAvailabilityMessage) {
        return null;
    }

    return (
        <StyledBox extendedStyles={styles.container}>
            <Typography {...styles.title}>{title}</Typography>
            <Typography {...styles.message}>{inventory?.additionalResults?.customAvailabilityMessage}</Typography>
        </StyledBox>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCustomAvailabilityMessage),
    definition: {
        displayName: "Custom Availability Message",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Fulfillment Note",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
